var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_2120",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_2120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.541 13.0584C10.6577 12.7584 10.5827 12.4167 10.3493 12.1834L8.60768 10.4667L8.63268 10.4417C10.0445 8.8726 11.0993 7.01607 11.7243 5.00002H13.341C13.791 5.00002 14.166 4.62502 14.166 4.17502V4.15835C14.166 3.70835 13.791 3.33335 13.341 3.33335H8.33268V2.50002C8.33268 2.04169 7.95768 1.66669 7.49935 1.66669C7.04101 1.66669 6.66601 2.04169 6.66601 2.50002V3.33335H1.65768C1.20768 3.33335 0.83268 3.70835 0.83268 4.15835C0.83268 4.61669 1.20768 4.98335 1.65768 4.98335H10.141C9.56936 6.63703 8.67099 8.15886 7.49935 9.45835C6.82435 8.71669 6.25768 7.90835 5.78268 7.05835C5.72 6.94029 5.62641 6.84149 5.51192 6.7725C5.39743 6.70351 5.26635 6.66694 5.13268 6.66669C4.55768 6.66669 4.19101 7.29169 4.47435 7.79169C4.99935 8.73335 5.64101 9.63335 6.39101 10.4667L2.74935 14.0584C2.67022 14.1352 2.60732 14.2272 2.56437 14.3289C2.52142 14.4305 2.49929 14.5397 2.49929 14.65C2.49929 14.7604 2.52142 14.8696 2.56437 14.9712C2.60732 15.0728 2.67022 15.1648 2.74935 15.2417C3.07435 15.5667 3.59935 15.5667 3.93268 15.2417L7.49935 11.6667L9.18268 13.35C9.60768 13.775 10.3327 13.6167 10.541 13.0584ZM14.5827 8.33335C14.0827 8.33335 13.6327 8.64169 13.4577 9.11669L10.3993 17.2834C10.1993 17.7917 10.5827 18.3334 11.1243 18.3334C11.4493 18.3334 11.741 18.1334 11.8577 17.825L12.5993 15.8334H16.5577L17.3077 17.825C17.4243 18.125 17.716 18.3334 18.041 18.3334C18.5827 18.3334 18.966 17.7917 18.7743 17.2834L15.716 9.11669C15.5327 8.64169 15.0827 8.33335 14.5827 8.33335ZM13.2327 14.1667L14.5827 10.5584L15.9327 14.1667H13.2327Z",
    fill: "#AAA9F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.c78a271880f22ae378a770d940307d83.svg";
export { ForwardRef as ReactComponent };